/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { Operation } from '../../core/models/common/Operation';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { IOasParameterParent } from '../../openapi/models/IOasParameterParent';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasParameter } from '../../openapi/models/OasParameter';
import { OasPathItem } from '../../openapi/models/OasPathItem';

/**
 * A command used to rename a parameter.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class RenameParameterCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldParamName : string;

    public _newParamName : string;

    public _paramIn : string;

    /*private*/ isPathItem : boolean;

    /*private*/ isOperation : boolean;

    public constructor(parent? : any, oldParamName? : any, newParamName? : any, paramIn? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasParameterParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasParameterParent") >= 0)) || parent === null) && ((typeof oldParamName === 'string') || oldParamName === null) && ((typeof newParamName === 'string') || newParamName === null) && ((typeof paramIn === 'string') || paramIn === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParamName===undefined) this._oldParamName = null;
            if(this._newParamName===undefined) this._newParamName = null;
            if(this._paramIn===undefined) this._paramIn = null;
            if(this.isPathItem===undefined) this.isPathItem = false;
            if(this.isOperation===undefined) this.isOperation = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParamName===undefined) this._oldParamName = null;
            if(this._newParamName===undefined) this._newParamName = null;
            if(this._paramIn===undefined) this._paramIn = null;
            if(this.isPathItem===undefined) this.isPathItem = false;
            if(this.isOperation===undefined) this.isOperation = false;
            (() => {
                this._oldParamName = oldParamName;
                this._newParamName = newParamName;
                this._paramIn = paramIn;
                this._parentPath = Library.createNodePath(<Node><any>parent);
            })();
        } else if(parent === undefined && oldParamName === undefined && newParamName === undefined && paramIn === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParamName===undefined) this._oldParamName = null;
            if(this._newParamName===undefined) this._newParamName = null;
            if(this._paramIn===undefined) this._paramIn = null;
            if(this.isPathItem===undefined) this.isPathItem = false;
            if(this.isOperation===undefined) this.isOperation = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParamName===undefined) this._oldParamName = null;
            if(this._newParamName===undefined) this._newParamName = null;
            if(this._paramIn===undefined) this._paramIn = null;
            if(this.isPathItem===undefined) this.isPathItem = false;
            if(this.isOperation===undefined) this.isOperation = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameParameterCommand] Executing.");
        this._doParameterRename(document, this._oldParamName, this._newParamName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameParameterCommand] Reverting.");
        this._doParameterRename(document, this._newParamName, this._oldParamName);
    }

    /**
     * Does the work of renaming a param from one name to another.
     * @param {Document} document
     * @param {string} from
     * @param {string} to
     * @private
     */
    /*private*/ _doParameterRename(document : Document, from : string, to : string) {
        let parent : IOasParameterParent = <IOasParameterParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let param : OasParameter = parent.getParameter(this._paramIn, from);
        if(this.isNullOrUndefined(param)) {
            return;
        }
        let allParams : Array<OasParameter> = <any>([]);
        /* add */(allParams.push(param)>0);
        this.isPathItem = false;
        this.isOperation = false;
        VisitorUtil.visitNode(<Node><any>parent, new RenameParameterCommand.RenameParameterCommand$0(this));
        let methods : Array<string> = NodeCompat.asList("get", "put", "post", "delete", "options", "head", "patch", "trace");
        if(this.isPathItem) {
            let pathItem : OasPathItem = <OasPathItem><any>parent;
            for(let index208=0; index208 < methods.length; index208++) {
                let method = methods[index208];
                {
                    let op : OasOperation = <OasOperation>NodeCompat.getProperty(pathItem, method);
                    if(!this.isNullOrUndefined(op)) {
                        let opParam : OasParameter = op.getParameter(this._paramIn, from);
                        if(!this.isNullOrUndefined(opParam)) {
                            /* add */(allParams.push(opParam)>0);
                        }
                    }
                }
            }
        }
        if(this.isOperation) {
            let operation : OasOperation = <OasOperation><any>parent;
            let pathItem : OasPathItem = <OasPathItem>operation.parent();
            let pparam : OasParameter = pathItem.getParameter(this._paramIn, from);
            if(!this.isNullOrUndefined(pparam)) {
                /* add */(allParams.push(pparam)>0);
                for(let index209=0; index209 < methods.length; index209++) {
                    let method = methods[index209];
                    {
                        let peerOperation : OasOperation = <OasOperation>NodeCompat.getProperty(pathItem, method);
                        if(ModelUtils.isDefined(peerOperation) && peerOperation !== operation) {
                            let opParam : OasParameter = peerOperation.getParameter(this._paramIn, from);
                            if(!this.isNullOrUndefined(opParam)) {
                                /* add */(allParams.push(opParam)>0);
                            }
                        }
                    }
                }
            }
        }
        allParams.forEach((p) => {
            p.name = to;
        });
    }
}
RenameParameterCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameParameterCommand";
RenameParameterCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameParameterCommand {

    export class RenameParameterCommand$0 extends CombinedVisitorAdapter {
        public __parent: any;
        /**
         * 
         * @param {OasPathItem} node
         */
        public visitPathItem(node : OasPathItem) {
            this.__parent.isPathItem = true;
        }

        /**
         * 
         * @param {Operation} node
         */
        public visitOperation(node : Operation) {
            this.__parent.isOperation = true;
        }

        constructor(__parent: any) {
            super();
            this.__parent = __parent;
        }
    }
    RenameParameterCommand$0["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}



